<template>
  <h1>
    <slot></slot>
  </h1>
</template>

<style scoped lang="scss">
h1 {
  height: 2em;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  text-transform: uppercase;
}
</style>
